import React, { useState } from 'react'
import ViewQuestions from './ViewQuestions'
import AIRecommendedQuestionnaireUpdate from './AIRecommendedQuestionnaireUpdate';

const ViewQuestionnaireContainer = (props: any) => {
    const { closeHandler, requestParams, updateContent, ...rest } = props;
    const [enabledUpdate, setEnabledUpdate] = React.useState(false);
    const [content, setContent] = useState(rest);
    const [selectedoptions, setSelectedOptions] = React.useState([] as any);
    const [questionIndex, setQuestionIndex] = React.useState<any>();
    const [enabledOptions, setEnabledOptions] = React.useState<any>([]);

    const getAiRecommendation = (selected, questionIndex) => {
        setQuestionIndex(questionIndex)
        setSelectedOptions(selected);
        setEnabledUpdate(true);
    }
    const onOptionChange = (opt) => {
        if (selectedoptions.includes(opt)) {
            setSelectedOptions(selectedoptions.filter((item: any) => item !== opt))
        } else {
            setSelectedOptions([...selectedoptions, opt])
        }
    }
    const backToQuestions = () => {
        setEnabledUpdate(false);
    }
    const updateTableData = (data) => {
        setContent(data);
        setEnabledUpdate(false);
        updateContent(data);
    }    
    const handleSetEnabledOptions = (data) => {
        setEnabledOptions(data);
    }    

    return (
        <>
            {!enabledUpdate && <ViewQuestions setEnabledOptions={handleSetEnabledOptions} content={content} closeHandler={closeHandler} enabledUpdate={enabledUpdate} getAiRecommendation={getAiRecommendation} />}
            {enabledUpdate && <AIRecommendedQuestionnaireUpdate enabledOptions={enabledOptions} content={content} updateTableData={updateTableData} requestParams={requestParams} questionIndex={questionIndex} selectedOptions={selectedoptions} backToQuestions={backToQuestions} onOptionChange={onOptionChange} />} 
        </>
    )
}

export default ViewQuestionnaireContainer